import fetch from 'isomorphic-unfetch'

const error = (response) =>
  response.json().then(
    (body) =>
      /* eslint-disable prefer-promise-reject-errors */
      Promise.reject({
        status: response.status,
        message: body,
      }),
    /* eslint-enable prefer-promise-reject-errors */
    () =>
      /* eslint-disable prefer-promise-reject-errors */
      Promise.reject({
        status: response.status,
      })
    /* eslint-enable prefer-promise-reject-errors */
  )

export const fetchJson: typeof fetch = (path, options) =>
  fetch(path, options).then((response) => {
    if (response.status === 200 || response.status === 201) {
      return response.json()
    }
    return error(response)
  })

const fetchJsonNoError: typeof fetch = (path, options) =>
  fetch(path, options).then((response) => response.json())

export const request = (path, method = 'GET', data, additionalHeader) =>
  fetchJson(path, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...additionalHeader,
    },
    ...(data ? { data: JSON.stringify(data) } : {}),
  })

export const authCall = (path, method = 'GET', noError, additionalHeader) => {
  const options: Parameters<typeof fetch>[1] = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...additionalHeader,
    },
  }
  if (noError) return fetchJsonNoError(path, options)
  return fetchJson(path, options)
}

export const tokenCall = (token, path, method = 'GET', data, additionalHeaders) =>
  fetchJson(path, {
    method,
    headers: {
      Accept: 'application/vnd.com.easybib.data+json',
      Authorization: `Bearer ${token}`,
      ...additionalHeaders,
    },
    ...(data ? { body: JSON.stringify(data) } : {}),
  })
